import { gql } from '@apollo/client'

export const CREATE_HERMINE_REQUEST_MUTATION = gql`
  mutation createHermineRequest($attributes: HermineRequestInput!) {
    createHermineRequest(attributes: $attributes) {
      id
      response
    }
  }
`
